import { Lock } from 'lucide-react';
import { Badge } from '../ui/badge';
export function PrivateMeetingLabel() {
    return (<Badge variant="secondary">
      <Lock className="h-3.5 w-3.5"/>
      Private
    </Badge>);
}
